export const BEGIN_AGAIN_URL = '/legal-check-form';
export const FINISH_URL = 'https://cian.ru';

export const PAYMENT_PENDING_TEST_ID = 'payment-pending';
export const PAYMENT_CANCELED_TEST_ID = 'payment-canceled';
export const PAYMENT_ERROR_TEST_ID = 'payment-error';
export const PAYMENT_SUCCESS_TEST_ID = 'payment-success';

export const PAYMENT_STATUS_UPDATE_INTERVAL = 10000;
